import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useConfirmation } from "../hooks/useConfirmation";
import { ReceiptHeader, BankTransferNotice, JerseyGift, OrderSummaryBlock } from "../components/confirmation/ConfirmationParts";

const Loading = () => <div><Navbar /><div className="max-w-xl mx-auto px-4 py-24 text-center text-slate-500">Loading...</div></div>;

export default function Confirmation() {
  const { reference } = useParams();
  const { data, jerseySize, setJerseySize, setEmail, busy, saveSize } = useConfirmation(reference);
  if (!data) return <Loading />;

  const o = data.order;
  const pending = o.registration_status === "pending_payment" && o.payment_method === "bank";

  return (
    <div><Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div data-testid="confirmation-receipt-card" className="rounded-2xl bg-white border border-[#E2EBF0] shadow-xl overflow-hidden">
          <ReceiptHeader order={o} />
          <div className="p-6 space-y-5">
            {pending && <BankTransferNotice order={o} bank={data.bank_details} />}
            {data.gift && !data.locked && <JerseyGift gift={data.gift} size={jerseySize} setSize={setJerseySize} onSave={saveSize} />}
            <OrderSummaryBlock order={o} locked={data.locked} onEmail={setEmail} busy={busy} />
            <div className="text-xs text-slate-400 text-center pt-2">Sporting CP Camp San Diego 2027 &middot; Point Loma Nazarene University &middot; June 9-13, 2027</div>
          </div>
        </div>
      </div>
    </div>
  );
}
